import React from "react";
import jet from "@randajan/jet-react";
import { Block } from "@randajan/jet-react/dom/block";

import { ProfileHeader } from "./ProfileHeader/ProfileHeader";
import { ProfilePrivate } from "./ProfilePrivate/ProfilePrivate";

import "./Profile.scss";
import { useVault } from "@randajan/vault-kit/react";
import { useBeam } from "@randajan/bifrost/client/react";
import { userStatsVault } from "../../assets/vaults/userStatsVault";
import { globalStatsBeam } from "../../assets/beams/globalStatsBeam";


import "./Profile.scss";
import { StatsPanel } from "./StatsPanel/StatsPanel";
import { CharacterRow } from "./CharacterRow/CharacterRow";
import { E404 } from "../Errors/E404/E404";

export const Profile = (props)=>{
    const { showMe, aliasKey, className } = props;

    const { data:usedStats, status } = showMe ? useVault(userStatsVault) : useBeam(globalStatsBeam);

    const realPofile = usedStats?.users.list.find(u=>(showMe ? u.isMe : u.aliasKey === aliasKey));
    const profile = realPofile || {};
    const { isMe } = profile;

    const classNames = ["Profile wall -gaps", className, isMe ? "isMe" : ""];

    if (!showMe && !realPofile && status != "pull") { return <E404/>; }

    return (
        <Block tagName="section" className={jet.melt(classNames, " ")} level={0}>
            {realPofile && <section className="slab wall -column -gaps">
                <ProfileHeader profile={profile} showMe={showMe}/>
                <CharacterRow profile={profile} showMe={showMe}/>
                <StatsPanel profile={profile} showMe={showMe}/>
                {showMe ? <ProfilePrivate profile={profile}/> : null}
            </section>}
        </Block>
    );
};
